import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "./alaram copy.mp3";

const Grocerycashbillingdata = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [vendorId, setVendorId] = useState(null);
  const scrollContainerRef = useRef(null);

  const notificationSound = new Audio(sound);

  // 🟢 Get vendorId from localStorage
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  // 🟢 Fetch pending "Cash" orders for vendor
  useEffect(() => {
    if (!vendorId) return;

    let previousOrderIds = [];

    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          console.error("Authorization token is missing");
          return;
        }

        const response = await axios.get(
          `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/getall/${vendorId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        // 🟢 Use "orderItems" instead of "items"
        const pendingCashOrders = response.data.filter(
          (order) =>
            order.paymentStatus === "PENDING" &&
            order.orderStatus === "CONFIRMED"
        );

        const newOrderIds = pendingCashOrders.map((o) => o.orderId);
        const isNewOrder = newOrderIds.some(
          (id) => !previousOrderIds.includes(id)
        );

        if (isNewOrder) {
          notificationSound.play().catch((e) =>
            console.warn("Autoplay prevented:", e)
          );
        }

        previousOrderIds = newOrderIds;
        setOrders(pendingCashOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
    const intervalId = setInterval(fetchOrders, 3000);
    return () => clearInterval(intervalId);
  }, [vendorId]);

  // 🟢 Auto scroll
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;
    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1;
          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0;
          }
        }
      }, 20);
    };

    startScrolling();
    return () => clearInterval(interval);
  }, [isHovered]);

  // 🟢 Color code orders
  const getOrderColor = (orderType) => {
    const normalized = (orderType || "").trim().toLowerCase();
    switch (normalized) {
      case "dine_in":
        return "#1E90FF";
      case "takeaway":
        return "#FF6347";
      case "delivery":
        return "#20B2AA";
      case "table_dine_in":
        return "#1E90FF";
      default:
        return "#FF6347";
    }
  };

  const handleOrderClick = (order) => {
    setExpandedOrder(
      expandedOrder && expandedOrder.orderId === order.orderId ? null : order
    );
  };

  const handleCheckboxChange = (orderId, itemIndex) => {
    const key = `${orderId}-${itemIndex}`;
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // 🟢 Accept order
  const handleAcceptOrder = async (e, orderId) => {
    e.stopPropagation();
    try {
      const status = "PROCESSING";
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.error("❌ No auth token found");
        return;
      }

      // ✅ Correct API format — use query params instead of path variables
      const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/orders/status?orderId=${orderId}&orderStatus=${status}`;

      const response = await axios.put(url, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      // ✅ Log the success response (for verification)
      // console.log("✅ Order updated successfully:", response.data);

      // ✅ Remove the updated order from the list
      setOrders((prev) => prev.filter((o) => o.orderId !== orderId));
    } catch (error) {
      console.error("❌ Failed to update order:", error);
      alert("Failed to update order: " + (error.response?.data || error.message));
    }
  };


  // 🟢 Decline order
  const handleDeclineOrder = async (e, orderId) => {
    e.stopPropagation();
    try {
      const status = "CANCELLED";
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.error("❌ No auth token found");
        return;
      }

      // ✅ Correct API format — use query params instead of path variables
      const url = `http://10.10.222.102:8084/freshandgroceries-0.0.1-SNAPSHOT/api/vendor/grocery/orders/status?orderId=${orderId}&orderStatus=${status}`;

      const response = await axios.put(url, null, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      // ✅ Log the success response (for verification)
      // console.log("✅ Order updated successfully:", response.data);

      // ✅ Remove the updated order from the list
      setOrders((prev) => prev.filter((o) => o.orderId !== orderId));
    } catch (error) {
      console.error("❌ Failed to update order:", error);
      alert("Failed to update order: " + (error.response?.data || error.message));
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "110px",
        bottom: "20px",
        right: "16px",
        borderRadius: "8px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
      }}
      className="mobilescroll"
    >
      <div
        ref={scrollContainerRef}
        style={{
          flexGrow: 1,
          overflowY: "auto",
          paddingRight: "5px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="hide-scrollbar"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {orders.length === 0 ? (
          <p style={{ color: "#555", textAlign: "center" }}>
            No pending cash orders found.
          </p>
        ) : (
          orders.map((order, index) => (
            <div
              key={`${order.orderId}-${index}`}
              onClick={() => handleOrderClick(order)}
              className="card scroll-data-responsive"
              style={{
                cursor: "pointer",
                width: "300px",
                marginBottom: "10px",
                background: getOrderColor(order.orderType),
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                padding: "10px",
                transition: "all 0.3s ease",
                height:
                  expandedOrder && expandedOrder.orderId === order.orderId
                    ? "auto"
                    : "120px",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "#fff",
                    fontWeight: "bold",
                  }}
                >
                  <p>Order ID: #{order.orderId}</p>
                  <h5 style={{ marginTop: "-15px" }}>
                    {order.orderType || "N/A"}
                  </h5>
                </div>

                {expandedOrder &&
                  expandedOrder.orderId === order.orderId && (
                    <div style={{ marginTop: "-10px" }}>
                      <h6 style={{ color: "#fff", fontSize: "20px" }}>
                        Items:
                      </h6>
                      <ul
                        style={{
                          listStyle: "none",
                          padding: 0,
                          marginLeft: "60px",
                          fontWeight: "bold",
                        }}
                      >
                        {(order.orderItems || []).map((item, idx) => (
                          <li
                            key={idx}
                            style={{
                              color: "#000",
                              fontSize: "20px",
                              marginBottom: "2px",
                            }}
                          >
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <input
                                type="checkbox"
                                checked={!!checkedItems[`${order.orderId}-${idx}`]}
                                onClick={(e) => e.stopPropagation()}
                                onChange={() =>
                                  handleCheckboxChange(order.orderId, idx)
                                }
                              />
                              {item.groceryItemName} × {item.quantity}
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                  }}
                >
                  <button
                    onClick={(e) => handleAcceptOrder(e, order.orderId)}
                    style={{
                      padding: "8px",
                      backgroundColor: "rgb(177 93 198)",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "bold",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Accept
                  </button>
                  <button
                    onClick={(e) => handleDeclineOrder(e, order.orderId)}
                    style={{
                      padding: "8px",
                      backgroundColor: "rgb(177 93 198)",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "bold",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Decline
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Grocerycashbillingdata;
